"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

var _actionTypes = require("../cart/action-types");

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _store = require("linksoft/core/store");

var _store2 = _interopRequireDefault(_store);

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App', 'DataTables');

var catalogService = abp.services.api.catalog;

var CartAppender = function () {
    function CartAppender(wrapperElement, identifierId, amount, allItemsData, catalogId) {
        var _this = this;

        (0, _classCallCheck3.default)(this, CartAppender);

        this.catalogId = catalogId;
        this.allItemsData = allItemsData;

        var inputClass = 'input-number-cart';
        var tabIndex = wrapperElement.parentElement.parentElement.querySelectorAll("." + inputClass).length + 99999;

        var amountInput = _Common2.default.createElement('input', wrapperElement, {
            type: 'text',
            className: inputClass,
            value: amount,
            tabindex: tabIndex
        });
        amountInput.setAttribute('placeholder', 0);
        amountInput.setAttribute('tabindex', tabIndex);
        amountInput.dataset.productId = identifierId;
        amountInput.dataset.originalValue = amount;
        amountInput.addEventListener('change', this.amountChanged.bind(this));
        amountInput.addEventListener('keydown', function (event) {
            event.target.dataset.previousValue = event.target.value;
        });
        amountInput.addEventListener('keyup', this.amountInputUp.bind(this));
        amountInput.addEventListener('focusout', function (event) {
            _this.removePendingClass(event.target);
        });
        return amountInput;
    }

    (0, _createClass3.default)(CartAppender, [{
        key: "removePendingClass",
        value: function removePendingClass(element) {
            element.classList.remove('pending-change');
        }
    }, {
        key: "amountInputUp",
        value: function amountInputUp(event) {
            var triggeringInput = event.target;

            if (['Enter', 'ArrowUp', 'ArrowDown'].indexOf(event.key) > -1) {
                this.changeFocus(event.code === 'ArrowUp' ? -1 : 1, triggeringInput);
                return;
            }

            if (triggeringInput.dataset.originalValue === triggeringInput.value) this.removePendingClass(triggeringInput);else triggeringInput.classList.add('pending-change');

            if (triggeringInput.value === '') return;

            var numberRegex = /^[0-9]{1,3}$/;
            if (!numberRegex.test(triggeringInput.value)) {
                triggeringInput.value = numberRegex.test(triggeringInput.dataset.previousValue) ? triggeringInput.dataset.previousValue : triggeringInput.dataset.previousValue.match(numberRegex);
            }
        }
    }, {
        key: "changeFocus",
        value: function changeFocus(changeValue, triggeringInput) {
            var inputsArray = [].concat((0, _toConsumableArray3.default)(document.getElementsByClassName('input-number-cart')));
            var inputIndex = inputsArray.indexOf(triggeringInput);
            var changedIndex = inputIndex + changeValue;
            if (inputIndex < 0 || changedIndex < 0 || changedIndex > inputsArray.length) return;

            inputsArray[changedIndex].focus();
        }
    }, {
        key: "adjustCartDataByServerResponse",
        value: function adjustCartDataByServerResponse(result, cartData, element) {
            var _this2 = this;

            if (result.messages && !result.showMessagesAsPopup) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(result.messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var message = _step.value;

                        _notify2.default.warn(message);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            var itemAmount = {},
                item = {};
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                var _loop = function _loop() {
                    var change = _step2.value;

                    if (item = cartData.items.find(function (cd) {
                        return cd.productId === change.productId;
                    })) {
                        item.amount = change.newAmount;
                        _this2.calcItemTotalPrice(item, item.amount);
                    }
                    if (itemAmount = cartData.itemAmounts.find(function (cd) {
                        return cd.productId === change.productId;
                    })) {
                        itemAmount.amount = change.newAmount;
                    }
                    if (element.dataset.productId === change.productId.toString()) {
                        element.value = change.newAmount === 0 ? '' : change.newAmount;
                    }
                };

                for (var _iterator2 = (0, _getIterator3.default)(result.changes || []), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.calculateCartTotalPrice(cartData);
            return item;
        }
    }, {
        key: "amountChanged",
        value: function amountChanged(event) {
            var _this3 = this;

            var cartData = _Common2.default.getCartData();
            var element = event.target;
            var amount = parseInt(element.value.match(/[0-9]{1,3}/g)) || 0;
            var productId = parseInt(element.dataset.productId);

            var item = cartData.items.find(function (cd) {
                return cd.productId === productId;
            });
            var changeType = _actionTypes2.default.CHANGE_AMOUNT;
            var adjustedItemAmounts = this.adjustItemsAmountItems(item, productId, cartData, changeType, amount, element);
            changeType = adjustedItemAmounts.changeType;
            var itemWithAmount = adjustedItemAmounts.itemAmount;
            itemWithAmount.catalogId = this.catalogId;
            this.calculateCartTotalPrice(cartData);

            // callback to save item on server
            catalogService.addToCart(itemWithAmount).done(function (result) {
                console.debug('Cart item was added on server side.', result);
                element.dataset.originalValue = amount.toString();
                item = _this3.adjustCartDataByServerResponse(result, cartData, element);
                _store2.default.get().dispatch({ type: changeType, cart: cartData });
            }).fail(function (result) {
                _store2.default.get().dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                _notify2.default.error(Resx.Messages.CannotAddToCart);
                console.error('Error in calling endpoint catalogService.AddToCart.', result);
            });
            event.target.classList.remove('pending-change');
        }
    }, {
        key: "calcItemTotalPrice",
        value: function calcItemTotalPrice(item) {
            item.price.totalPrice.standardPrice = item.price.totalPrice.finalPrice = item.price.unitPrice.standardPrice * item.amount;
        }
    }, {
        key: "adjustItemsAmountItems",
        value: function adjustItemsAmountItems(item, productId, cartData, changeType, amount, element) {
            if (!item) {
                // if missing in cart, find it in current page data
                item = this.allItemsData.find(function (c) {
                    return c.id === productId;
                });
                item.productId = productId;
                item.productName = item.name;
                cartData.items.push(item);
                changeType = _actionTypes2.default.UPDATE;
            } else if (amount === 0) {
                cartData.items.splice(cartData.items.indexOf(item), 1);
            }

            if (!item.price) item.price = {};
            if (!item.price.unitPrice) item.price.unitPrice = {};
            if (!item.price.unitPrice.finalPrice) item.price.unitPrice.finalPrice = item.standardPrice;
            if (!item.price.unitPrice.standardPrice) item.price.unitPrice.standardPrice = item.standardPrice;
            if (!item.price.totalPrice) item.price.totalPrice = {};
            item.amount = amount;
            this.calcItemTotalPrice(item);

            var itemAmount = cartData.itemAmounts.find(function (cd) {
                return cd.productId === productId;
            });
            if (!itemAmount) {
                itemAmount = function (_ref) {
                    var productId = _ref.productId,
                        amount = _ref.amount,
                        id = _ref.id;
                    return { productId: productId, amount: amount, id: id };
                }(item);
                cartData.itemAmounts.push(itemAmount);
            } else if (amount === 0) {
                cartData.itemAmounts.splice(cartData.itemAmounts.indexOf(item), 1);
                element.value = '';
            }
            itemAmount.amount = amount;
            return { changeType: changeType, itemAmount: itemAmount };
        }
    }, {
        key: "calculateCartTotalPrice",
        value: function calculateCartTotalPrice(cartData) {
            cartData.totalPrice.finalPrice = !cartData.items || cartData.items.length === 0 ? 0 : cartData.items.map(function (i) {
                return i.price.totalPrice.finalPrice;
            }).reduce(function (total, num) {
                return total + num;
            });
        }
    }]);
    return CartAppender;
}();

exports.default = CartAppender;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/modules/cartAppender.js
// module id = 1193
// module chunks = 0